import React from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";

function WhatsNewPage() {
  return (
    <>
      <NavBar />
      <div>WhatsNewPage</div>
      <Footer />
    </>
  );
}

export default WhatsNewPage;
